<template>
  <v-app>
    <!-- <home-system-bar /> -->

    <home-app-bar
      v-if="this.$route.path != '/onboarding' || this.$route.name != 'landing'"
    />

    <home-view />

    <v-snackbar v-model="updateExists">
      An update is available. Please refresh the page to get the latest content

      <v-btn
        class="ml-2"
        right
        color="app"
        variant="text"
        @click="refreshApp()"
      >
        Refresh
      </v-btn>
    </v-snackbar>

    <home-footer v-if="this.$route.path != '/onboarding'" />

    <!-- <home-settings /> -->
  </v-app>
</template>
<script>
import update from "../../mixins/update";
export default {
  name: "HomeLayout",

  mixins: [update],

  data() {
    return {
      updateExists: false,
    };
  },

  methods: {
    updateAvailable(event) {
      console.log("updateAvailable event trigger", event);
      this.registration = event.detail;
      this.updateExists = true;

      this.refreshApp();
    },
    refreshApp() {
      window.location.reload();
    },
  },

  components: {
    HomeAppBar: () => import("@/layouts/home/AppBar"),
    HomeFooter: () => import("@/layouts/home/Footer"),
    HomeView: () => import("@/layouts/home/View"),
  },
};
</script>
